import { PhoneBook } from './PhoneBook/PhoneBook';

export const App = () => <PhoneBook />;
